import { IApiSuccessWrapper } from '$/types'
import { apiSlice } from 'app/services/api'
import {
  IQRAChartBaseObject,
  IQRAChartObjects,
  IQRAGraphBools
} from 'features/RiskManagement/Components/Graphs'
import {
  convertRiskUnitToAPIRiskValueParameter,
  ILocalFilter,
  RiskUnitType
} from 'features/RiskManagement/Components/LocalFilter'

const SYSTEM_SCOPE_ID_PARAM_NAME = 'systemScopeId'

export interface IGetQRAGraphsQueryParams {
  systemScopeId: string
  localFilter: ILocalFilter
  riskUnit: RiskUnitType
  graphSelections: IQRAGraphBools
  savedStateId1?: string
  savedStateId2?: string
  assessmentId?: string
  continuousRouteId?: string
}

export const qraGraphsApi = apiSlice.injectEndpoints({
  endpoints: (build) => ({
    getQRAGraphs: build.query<IQRAChartObjects, IGetQRAGraphsQueryParams>({
      query: ({
        systemScopeId,
        localFilter,
        riskUnit,
        graphSelections,
        savedStateId1,
        savedStateId2,
        assessmentId,
        continuousRouteId
      }) => ({
        method: 'POST',
        url: '/qra/graphs',
        params: {
          [SYSTEM_SCOPE_ID_PARAM_NAME]: systemScopeId,
          savedStateId1,
          savedStateId2,
          assessmentId,
          continuousRouteId
        },
        body: {
          localFilter,
          riskValue: convertRiskUnitToAPIRiskValueParameter(riskUnit),
          graphSelection: graphSelections
        }
      }),
      // providesTags: (_res, _err, args) => [{ type: 'Graphs', systemScopeId: args.systemScopeId }],
      transformResponse: (res: IApiSuccessWrapper) => {
        const charts: IQRAChartObjects = {}

        if (res?.result != null) {
          const rawCharts = res.result as IQRAChartBaseObject[]

          /**
           * Transform result from:
           *
           * result: [
           *   { graphType: 'riskbythreat, items: [] },
           *   { graphType: 'riskbyconsequence', items: [] },
           *   ...
           * ]
           *
           * To:
           *
           * charts: {
           *   riskbythreat: { graphType: 'riskbythreat, items: [] },
           *   riskbyconsequence: { graphType: 'riskbyconsequence', items: [] },
           *   ...
           * }
           */
          for (const chart of rawCharts) {
            charts[chart.graphType] = chart
          }
        }

        return charts
      }
    })
  })
})

export const { useGetQRAGraphsQuery } = qraGraphsApi
